module.exports = __webpack_public_path__ + "img/c06_unitstartechcargoexpansion_Normal_ua.dfb0587b.webp";